import { dateTimeToView, humanizedTimeRange } from "helpers/date";
import React from "react";
import { CircleMarker, Tooltip } from "react-leaflet";

const areEqual = (prevProps, nextProps) => {
    return prevProps.carStopsLoadedAt === nextProps.carStopsLoadedAt;
};

const CarStopPoints = React.memo((props) => {
    const { carStops, markerStyle } = props;
    return carStops.map((carStop, index) => <CarStopPoint key={index} carStop={carStop} markerStyle={markerStyle} />);
}, areEqual);

const CarStopPoint = ({ carStop, markerStyle }) => {
    const { location, startedAt, endedAt, duration } = carStop;
    const loc = [location[1], location[0]];
    const stopDuration = humanizedTimeRange(duration, "d [д.] h [ч.] m [мин.]");

    return (
        <CircleMarker center={loc} {...markerStyle} pane="markerPane">
            <Tooltip className="map__tooltip--default" direction="top">
                <span>
                    Остановка машины
                    <br />
                    {dateTimeToView(startedAt)} - {dateTimeToView(endedAt)} ({stopDuration}) (
                    {dateTimeToView(startedAt, "Z")})
                </span>
            </Tooltip>
        </CircleMarker>
    );
};

export default CarStopPoints;
